import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import { WithTranslation, withTranslation, Trans } from 'react-i18next';

import { tabStyle, tabStyleSecondary } from './TabStyles';
import { Grid, Button } from '@material-ui/core';
import { DARK_BUTTON_COLOR } from 'App';


export type Zakladka = {
    value: number, 
    panelOpis: string
}

interface ZakladkiProps {
    windowWidth: number,
    menuItems: Zakladka[],
    panel: number,
    setPanel: (p: number) => void,
    marginTop?: string,
    marginBottom?: string,
    fontSize?: string,

    lightMode: boolean
}



class Zakladki extends React.Component<ZakladkiProps & WithStyles<typeof styles> & WithTranslation> {


    render() {
        const { classes } = this.props;

        let marginTop = this.props.marginTop? this.props.marginTop : '20px'
        let marginBottom = this.props.marginBottom? this.props.marginBottom : '20px'
        let fontSize = this.props.fontSize? this.props.fontSize : '18px'

        let menuItems = this.props.menuItems

        return (
           <Grid container direction="row" alignItems='center' style={{ margin: `${marginTop} auto ${marginBottom}`, width: "85%" }}>

                {menuItems.map((item: Zakladka, index: number) => {
                    return (
                        <Grid key={item.value} item style={{ width: this.props.windowWidth <= 10000 ? "100%" : `calc((100% )/${menuItems.length})`, marginBottom: "3px" }}>
                            <Button
                                style={{ width: this.props.windowWidth < 10000 || index === menuItems.length - 1 ? "calc(100% )" : "calc(100% + -6px )", padding: "14px 0px", whiteSpace: "pre", fontSize: fontSize, }}
                                className={`${this.props.panel === item.value ? classes.inputChosen : classes.input} ${classes.border} ${this.props.panel === item.value ? classes.inputText : classes.inputAlt} ${!this.props.lightMode && this.props.panel !== item.value ? classes.dark : ""}`}
                                variant="outlined" //color="primary"
                                onClick={() => this.props.setPanel(item.value)}
                            >
                                {item.panelOpis}
                            </Button>
                        </Grid>
                    )
                })}

           </Grid>
        );
    }
}

const styles = (theme: Theme) => ({
    input: {
        fontSize: "18px",
        //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "18px",
        fontWeight: "bold" as "bold",
        //textTransform: "lowercase" as "lowercase",
        padding: "14px",
        height: "40px",
        //backgroundColor: tabStyle.colorMain,
        backgroundColor: tabStyle.colorBackground,
        //color: tabStyle.colorMain,
        "&:hover": {
          //background: tabStyleSecondary.colorHover, //"#007000",
          background: tabStyle.colorHover, //"#007000",
          color: tabStyle.colorText,
          //color: tabStyleSecondary.colorBackground,
        }
      },
      inputChosen: {
        fontSize: "18px",
        //fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "18px",
        fontWeight: "bold" as "bold",
        //textTransform: "lowercase" as "lowercase",
        padding: "14px",
        height: "40px",
        //backgroundColor: tabStyle.colorMain, //"#56d242",
        backgroundColor: tabStyle.colorHover, //"#56d242",
        //color: tabStyle.colorText,
        "&:hover": {
          //background: tabStyleSecondary.colorHover, //"#007000",
          //color: tabStyleSecondary.colorBackground,
          background: tabStyle.colorHover, 
          color: tabStyle.colorText,
        }
      },
      inputAlt: {
        //color: tabStyle.colorTextAlt
        color: tabStyle.colorMain
      },
      inputText: {
        color: tabStyleSecondary.colorText
        //color: tabStyle.colorText
      },
      border: {
        borderStyle: "solid",
        borderWidth: "1px 0px",
        borderColor: "lavender",
        borderRadius: "0px",
        //borderColor: theme.palette.primary.main,
        ///borderColor: "lightgrey",
        
        //borderRadius: "4px",
        // "&:hover": {
        //   //borderRadius: "4px",
        //   borderStyle: "solid",
        //   borderWidth: "2px",
        //   borderRadius: "0px",
        //   borderColor: "lavender",
        // },
      },
      dark: {
        backgroundColor: DARK_BUTTON_COLOR,
      }
});

export default withTranslation()(withStyles(styles)(Zakladki));